import { Link } from "react-router-dom";
import styled from "styled-components";
import { List, Close } from "@material-ui/icons";
import { useState, useEffect } from "react";
import { mobile, tablet } from "../responsive";

const Container = styled.div``;

const MenuContainer = styled.div`
    display: none;
    ${mobile({
        display: "flex",
        alignItems: "center",
        padding: "12px 16px",
        background: "var(--brand-black)",
        color: "var(--brand-white)",
        borderBottom: "1px solid var(--brand-rule)",
    })}
    ${tablet({
        display: "flex",
        alignItems: "center",
        padding: "12px 16px",
        background: "var(--brand-black)",
        color: "var(--brand-white)",
        borderBottom: "1px solid var(--brand-rule)",
    })}
`;

const Dropddown = styled.div`
    padding: 1.5rem 0 3rem;
    min-height: 100vh;
    color: var(--brand-white);
    background: var(--brand-black);
    display: flex;
    flex-direction: column;
    z-index: 99999;
    font-family: "FuturaPT-Demi", sans-serif;
`;

const MenuLink = styled(Link)`
    text-decoration: none;
    color: var(--brand-white);
    padding: 1.1rem 1.5rem;
    font-size: 1.15rem;
    letter-spacing: 0.04em;
    border-bottom: 1px solid rgba(193, 150, 82, 0.15);
    transition: color 0.25s ease;

    &:hover {
        color: var(--brand-gold);
    }
`;

const ExternalLink = styled.a`
    text-decoration: none;
    color: var(--brand-white);
    padding: 1.1rem 1.5rem;
    font-size: 1.15rem;
    letter-spacing: 0.04em;
    border-bottom: 1px solid rgba(193, 150, 82, 0.15);
    transition: color 0.25s ease;

    &:hover {
        color: var(--brand-gold);
    }
`;

const LogoContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`;

const Logo = styled.img`
    width: 80%;
    max-width: 200px;
`;

const Left = styled.div`
    flex: 1;
    display: flex;
    flex-direction: row;
    color: var(--brand-gold);
`;

const Center = styled.div`
    font-size: 1.5rem;
    cursor: pointer;
    font-family: FuturaPT-Bold;
    flex: 1;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const Right = styled.div`
    flex: 1;
    display: flex;
    justify-content: flex-end;
`;

const MobileNavbar = () => {
    const [showMenu, setShowMenu] = useState(false);

    useEffect(() => {
        document.body.style.overflow = showMenu ? "hidden" : "inherit";
    }, [showMenu]);

    const closeMenu = () => setShowMenu(false);

    return (
        <Container>
            <MenuContainer>
                <Left>
                    {showMenu ? (
                        <Close onClick={closeMenu} />
                    ) : (
                        <List onClick={() => setShowMenu(true)} />
                    )}
                </Left>
                <Center>
                    <Link to="/" style={{ textDecoration: "none" }}>
                        <LogoContainer>
                            <Logo
                                src={
                                    "https://ik.imagekit.io/dnddecpho/dndream/DD_LogoGold-300x53_9YWAdjFzX.png?updatedAt=1706110249831"
                                }
                                alt="D&Dream"
                            />
                        </LogoContainer>
                    </Link>
                </Center>
                <Right />
            </MenuContainer>
            {showMenu && (
                <Dropddown>
                    <MenuLink to="/" onClick={closeMenu}>
                        Home
                    </MenuLink>
                    <MenuLink to="/about" onClick={closeMenu}>
                        About
                    </MenuLink>
                    <MenuLink to="/team" onClick={closeMenu}>
                        Team
                    </MenuLink>
                    <MenuLink to="/training" onClick={closeMenu}>
                        Training
                    </MenuLink>
                    <MenuLink to="/contact" onClick={closeMenu}>
                        Contact
                    </MenuLink>
                    <ExternalLink
                        href="https://www.dnduser.com"
                        onClick={closeMenu}
                    >
                        Login
                    </ExternalLink>
                </Dropddown>
            )}
        </Container>
    );
};

export default MobileNavbar;
